module.exports = "https://cdn.realtymogul.com/static/media/img_nav_mr2.d537c54d.png";